import { render, staticRenderFns } from "./MicroPlayerBasicSkillSetup.vue?vue&type=template&id=06ae06e6&"
import script from "./MicroPlayerBasicSkillSetup.vue?vue&type=script&lang=js&"
export * from "./MicroPlayerBasicSkillSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports